export default "__VITE_ASSET__p9DzVdFQ__"